import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IRunViewRecommendationsTrainerParams {
}

export interface IRunViewRecommendationsTrainerResult {
}

export class RunViewRecommendationsTrainerRequest extends Request<IRunViewRecommendationsTrainerParams, IRunViewRecommendationsTrainerResult> {
  constructor(params: IRunViewRecommendationsTrainerParams = {}) {
    super('runViewRecommendationsTrainerTask', params);
  }
}
